/**
 * Production-safe logger. Only logs in development mode.
 * Replace console.log/error/warn with logger.log/error/warn.
 */
const isDev = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args) => { if (isDev) console.log(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};

export default logger;
